import { useMutation, useQuery } from "@apollo/client/react"; import React, { useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import SAVE_MANEJO_HERIDAS_VISITA_CD, { adaptManejoHeridasCDInput } from "../../../../../../data/graphQL/mutations/Visitas/saveManejoHeridasVisitaCD";
import { useVisita } from "../../../../../../context/VisitaContext";

import { useStepSave } from "../../../../hooks/useStepSave";
import { validateStepFields } from "../../../../utils/visitaStepValidation";
import { GET_COMBO_VISITA_VALOR, adaptCombosVisitas } from "../../../../../../data/graphQL/queries/MisVisitas/getCombosVisitaValor";
import { toast } from 'react-hot-toast';

const ID_ALTA_COMPLEJIDAD = 38;

const ID_COMBO_TIPO_HERIDA = 9;
const ID_COMBO_COMPLEJIDAD = 10;
const ID_COMBO_COMPLEJAS = 11;
const ID_COMBO_MODO_VAC = 12;

const esOpcionOtras = (opcion) => opcion.displayName.includes('Otras');

export const ManejoHeridas = ({ readOnly, onSaveRef, onExposeFormatted }) => {
  const [formData, setFormData] = useState({});
  const { visita, setVisita } = useVisita();
  const [tipoHeridaOptions, setTipoHeridaOptions] = useState([]);
  const [complejidadOptions, setComplejidadOptions] = useState([]);
  const [complejasOptions, setComplejasOptions] = useState([]);
  const [modoVACOptions, setModoVACOptions] = useState([]);

  const { data: dataComboVisita } = useQuery(GET_COMBO_VISITA_VALOR, {
    variables: { idComboVisita: ID_COMBO_TIPO_HERIDA }
  });

  useEffect(() => {
    if (!dataComboVisita) return;
    setTipoHeridaOptions(adaptCombosVisitas(dataComboVisita));
  }, [dataComboVisita]);

  const { data: dataComboComplejidad } = useQuery(GET_COMBO_VISITA_VALOR, {
    variables: { idComboVisita: ID_COMBO_COMPLEJIDAD }
  });

  useEffect(() => {
    if (!dataComboComplejidad) return;
    setComplejidadOptions(adaptCombosVisitas(dataComboComplejidad));
  }, [dataComboComplejidad]);

  const { data: dataComboComplejas } = useQuery(GET_COMBO_VISITA_VALOR, {
    variables: { idComboVisita: ID_COMBO_COMPLEJAS }
  });

  useEffect(() => {
    if (!dataComboComplejas) return;
    setComplejasOptions(adaptCombosVisitas(dataComboComplejas));
  }, [dataComboComplejas]);

  const { data: dataComboVac } = useQuery(GET_COMBO_VISITA_VALOR, {
    variables: { idComboVisita: ID_COMBO_MODO_VAC }
  });

  useEffect(() => {
    if (!dataComboVac) return;
    setModoVACOptions(adaptCombosVisitas(dataComboVac));
  }, [dataComboVac]);

  const [save] = useMutation(SAVE_MANEJO_HERIDAS_VISITA_CD);

  const formattedGroups = useMemo(() => {
    return groups.map((group) => {
      const formatedGroup = { ...group, title: formData?.idComboVisitaValorComplejidad === ID_ALTA_COMPLEJIDAD ? 'Heridas Complejas' : group.title };
      const formattedInputs = group.inputs.
        filter((input) => input.onlyAltaComplejidad && formData.idComboVisitaValorComplejidad === ID_ALTA_COMPLEJIDAD ||
          !input.onlyAltaComplejidad).
        map((input) => {
          const newInput = { ...input };

          if (input.name === "idComboVisitaValorTipoHerida") newInput.options = tipoHeridaOptions;

          if (input.name === "idComboVisitaValorComplejidad") newInput.options = complejidadOptions;

          if (input.name === "idComboVisitaValorComplejas") {
            newInput.options = complejasOptions;
            newInput.required = formData?.idComboVisitaValorComplejidad === ID_ALTA_COMPLEJIDAD;
          }

          if (input.name === "idComboVisitaValorModoVAC") newInput.options = modoVACOptions;

          if (['idComboVisitaValorTipoHerida', 'localizacion'].includes(input.name)) newInput.required = !!formData?.manejoHeridas;

          if (input.name === 'otrasHeridas') {
            const idOpcionOtras = tipoHeridaOptions.find(esOpcionOtras)?.id;
            newInput.required = !!formData?.manejoHeridas && formData?.idComboVisitaValorTipoHerida === idOpcionOtras;
          }

          if (input.name === 'indicacion') newInput.required = !!formData?.manejoHeridas || !formData?.manejoHeridas && formData?.idComboVisitaValorComplejidad === ID_ALTA_COMPLEJIDAD;

          if (['presionVAC', 'idComboVisitaValorModoVAC'].includes(input.name)) {
            newInput.required = !!formData?.vac;
            newInput.hidden = !formData?.vac;
          }

          if (!formData.manejoHeridas && newInput.name !== 'manejoHeridas') newInput.hidden = true;

          if (readOnly) newInput.disabled = true;

          return newInput;
        });

      return {
        ...formatedGroup,
        inputs: formattedInputs
      };
    });
  }, [readOnly, formData, tipoHeridaOptions, complejidadOptions, complejasOptions, modoVACOptions]);

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (name === 'manejoHeridas' && !value) {
      handleChange('idComboVisitaValorTipoHerida', null);
      handleChange('otrasHeridas', null);
      handleChange('localizacion', null);
      handleChange('idComboVisitaValorComplejidad', null);
      handleChange('idComboVisitaValorComplejas', null);
      handleChange('indicacion', null);
      handleChange('vac', false);
      handleChange('presionVAC', null);
      handleChange('idComboVisitaValorModoVAC', null);
    }

    if (name === 'vac' && !value) {
      handleChange('presionVAC', null);
      handleChange('idComboVisitaValorModoVAC', null);
    }
  };

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedGroups, formData });

    if (validate && !!formData?.vac && !!formData?.presionVAC && (formData?.presionVAC > -25 || formData?.presionVAC < -300)) {
      toast.error('La presion valida debe situarse entre -300 y -25');
      const error = new Error("Validación fallida");
      error.isCustomError = true;
      throw error;
    }

    const { data } = await save({ variables: { input: adaptManejoHeridasCDInput(formData) } });

    setVisita((prev) => ({
      ...prev,
      ...formData
    }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'manejoHeridasCD',
      stepName: 'Manejo de Heridas',
      formattedGroups
    });
  }, [onExposeFormatted, formattedGroups]);

  return (
    <>
      {formattedGroups.
        filter((group) => !group.hidden).
        map((group, idx) =>
          <CardBox key={idx} title={group.title}>
            <Grid container spacing={2}>
              {group.inputs.
                filter((input) => !input.hidden).
                map((input) =>
                  <Grid size={{ xs: 12 }} key={input.name}>
                    <RenderInputByTypeMobile
                      input={input}
                      value={formData[input.name]}
                      handleChange={handleChange} />

                  </Grid>
                )}
            </Grid>
          </CardBox>
        )
      }
    </>);

};

const groups = [{
  title: "Heridas Simples",
  inputs: [
    {
      name: "manejoHeridas",
      displayName: "Manejo de heridas",
      type: "boolean",
      required: true,
      lightTitle: true
    },
    {
      name: "idComboVisitaValorTipoHerida",
      displayName: "Tipo de herida",
      type: "select",
      required: false
    },
    {
      name: "otrasHeridas",
      displayName: "Otras",
      type: "string",
      required: false
    },
    {
      name: "localizacion",
      displayName: "Localización",
      type: "long_string",
      required: false
    },
    {
      name: "idComboVisitaValorComplejidad",
      displayName: "Complejidad",
      type: "select",
      required: false
    },
    {
      name: "idComboVisitaValorComplejas",
      displayName: "Complejas",
      type: "select",
      required: false,
      onlyAltaComplejidad: true
    },
    {
      name: "indicacion",
      displayName: "Indicacion",
      type: "long_string",
      required: false
    },
    {
      name: "vac",
      displayName: "VAC",
      type: "boolean",
      lightTitle: true,
      required: false,
      onlyAltaComplejidad: true
    },
    {
      name: "presionVAC",
      displayName: "Presion VAC",
      type: "int",
      required: false,
      onlyAltaComplejidad: true
    },
    {
      name: "idComboVisitaValorModoVAC",
      displayName: "Modo VAC",
      type: "select",
      required: false,
      onlyAltaComplejidad: true
    }]

}];